import { useEffect } from "react";
import { useAppDispatch } from "../../redux-store";
import { setOnlineStatus } from "../../ducks/app/network";

const useNetworkListener = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const updateOnlineStatus = () => {
      dispatch(setOnlineStatus(navigator.onLine));
    };

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, [dispatch]);
};

export default useNetworkListener;
